import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-info-config',
  templateUrl: 'info-config.component.html'
})
export class InfoConfigComponent implements OnInit {
  @Input() item: any;
  @Input() layout: number;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  constructor(
  ) {
  }

  ngOnInit() {
    console.log('ITEM ->', this.item);
    if (Array.isArray(this.item.url)) {
      if (this.item.url.length <= 0) {
        this.item.url = [];
      }
    } else {
      this.item.url = [];
    }
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

  getPhoto($event: any): void {
    this.item.favicon = $event.path;
  }

}
